export default {
  iconSet: "fal",

  general: {
    showHomeButton: true,
    canAddSoldPropertiesToFavourites: false,
  },

  filter: {
    enabled: true,
  },

  minimapPositionPage: "bottom",
  minimapPositionNowSelling: "bottom",

  skipOnlyChildSubsections: false,
};
